import Header from '@/components/layout/Header';
import { ROUTES } from '@/configs/constants';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import TermsCardItem from '../terms/components/TermsCardItem';

export default observer(function PolicyPage() {
    // store
    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1);
    };

    return (
        <div className='flex flex-col justify-start bg-white pt-[72px]'>
            <Header goBackFunction={goBack} title={t('text.privacyPolicy')} />
            <div className='px-4 pb-8'>
                {(() => {
                    const termsCards: any = [];
                    for (let i = 1; i <= 10; i++) {
                        termsCards.push(
                            <TermsCardItem
                                key={i}
                                title={t(`policy.title_${i}`)}
                                content={<div dangerouslySetInnerHTML={{ __html: t(`policy.content_${i}`) }} />}
                                isLast={i === 10}
                            />
                        );
                    }
                    return termsCards;
                })()}
            </div>

        </div>
    );
});
